export class FMLayout {

  Image_str: string;
  FileName: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/fm-layout.ts